module.exports = __webpack_public_path__ + "images/cebsblogo_white.1792381924319.png";